import moment from "moment";
import React from "react";
//import { size } from "lodash";
//import qs from 'query-string';
import { commonConstants } from "../constants";

//get the the utc to local time zone difference in seconds
const setTimeZoneDiff = function () {
  if (commonConstants.local_time_zone === null) {
    var d = new Date();
    var n = d.getTimezoneOffset();
    commonConstants.local_time_zone = -n * 60;
  }
};

const timeStampDateFormat = function (timestamp, format = "MM/DD/YYYY h:mma") {
  let formated_date = timestamp;

  if (timestamp) {
    formated_date = moment.unix(timestamp).format(format);
  }

  return formated_date;
};

const UTCTimeStampToLocal = function (timestamp) {
  //console.log(commonConstants.local_time_zone, "====")
  return (parseInt(timestamp) + commonConstants.local_time_zone) * 1000;
};

const LocalTimeStampToUTC = function (timestamp) {
  //console.log(commonConstants.local_time_zone, "====")
  return (parseInt(timestamp) - commonConstants.local_time_zone) * 1000;
};

const formatCurrency = function (amount = 0) {
  if (amount && !isNaN(amount)) {
    return parseFloat(amount, 10)
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,"); // 12,345.67
  } else {
    amount = 0;
  }

  return amount;
};

const formatPhoneNumber = function (phoneNumberString) {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = match[1] ? "+1 " : "";
    return (
      <a target="_blank" rel="noopener noreferrer" href={"tel:" + cleaned}>
        {[intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("")}
      </a>
    );
  }
  return null;
};

const formatEmail = function (emailString) {
  if (emailString) {
    return (
      <a target="_blank" rel="noopener noreferrer" href={"mailto:" + emailString}>
        {emailString}
      </a>
    );
  }
  return null;
};

const formatNumber = function (x, fraction = 2) {
  //return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //navigator.language or 'en-IN'
  return parseFloat(x).toLocaleString("en-IN", {
    minimumFractionDigits: fraction,
    maximumFractionDigits: fraction,
  }); // "1,234.57"
};

const getDateRanges = function () {
  let ranges = {
    Today: [
      moment().set({ hour: 0, minute: 0, second: 0 }),
      moment().set({ hour: 23, minute: 59, second: 59 }),
    ],
    Yesterday: [
      moment().set({ hour: 0, minute: 0, second: 0 }).subtract(1, "days"),
      moment().set({ hour: 23, minute: 59, second: 59 }).subtract(1, "days"),
    ],
    "Last 7 Days": [
      moment().set({ hour: 0, minute: 0, second: 0 }).subtract(6, "days"),
      moment().set({ hour: 23, minute: 59, second: 59 }),
    ],
    "Last 30 Days": [
      moment().set({ hour: 0, minute: 0, second: 0 }).subtract(29, "days"),
      moment().set({ hour: 23, minute: 59, second: 59 }),
    ],
    /*
      "Last 60 Days": [
        moment().set({hour:0,minute:0,second:0}).subtract(59, "days"), 
        moment().set({hour:23,minute:59,second:59})
      ],
      "Last 90 Days": [
        moment().set({hour:0,minute:0,second:0}).subtract(89, "days"), 
        moment().set({hour:23,minute:59,second:59})
      ],
      "Last 120 Days": [
        moment().set({hour:0,minute:0,second:0}).subtract(119, "days"), 
        moment().set({hour:23,minute:59,second:59})
      ],
      */
    "This Month": [
      moment().set({ hour: 0, minute: 0, second: 0 }).startOf("month"),
      moment().set({ hour: 23, minute: 59, second: 59 }).endOf("month"),
    ],
    "Last Month": [
      moment().set({ hour: 0, minute: 0, second: 0 }).subtract(1, "month").startOf("month"),
      moment().set({ hour: 23, minute: 59, second: 59 }).subtract(1, "month").endOf("month"),
    ],
  };
  return ranges;
};
const getTimeStampFromDateRange = function (value) {
  let ranges = getDateRanges(),
    result = {};
  if (Object.prototype.hasOwnProperty.call(ranges, value)) {
    result = {
      from: Math.floor(ranges[value][0] / 1000),
      to: Math.floor(ranges[value][1] / 1000),
    };
  }
  return result;
};

const removeEmptyObjects = function (objects_in) {
  Object.keys(objects_in).forEach(
    (key) => (objects_in[key] === null || objects_in[key] === "") && delete objects_in[key]
  );
  return objects_in;
};

const appendScript = (scriptToAppend) => {
  const script = document.createElement("script");
  script.src = scriptToAppend;
  script.async = true;
  document.body.appendChild(script);
};

//Convert array to select options
const convertToOptions = (data, id, label) => {
  let select_options = [];
  if (data) {
    for (let index in data) {
      select_options.push({
        value: data[index][id],
        label: data[index][label],
      });
    }
  }
  return select_options;
};

//get the value from array
const getValueFromArray = (data) => {
  return data.map(({ value }) => value);
};

//get mapped/selected sendsor parameter
const getSelectedSensorParameters = (sensorId, allSensors, allSensorParameters) => {
  const sensor = allSensors.find(
    (sensor) => parseInt(sensor.sensor_id, 10) === parseInt(sensorId, 10)
  );
  const sensorTypeId = (sensor && sensor.sensor_type_id) || "";
  const sensorParameters = allSensorParameters.filter(
    (sensorParameter) => sensorParameter.sensor_type_id === sensorTypeId
  );
  return sensorParameters;
};

// Function to encode plainText using a Vigenère cipher with a keyword
const encode = (plainText) => {
  const keyword = commonConstants.encryptionKey.toLowerCase();
  const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
  let encodedText = "";

  // Convert plainText to a string
  plainText = plainText.toString();

  for (let i = 0; i < plainText.length; i++) {
    let plainChar = plainText[i];
    let keyChar = keyword[i % keyword.length];
    let plainIndex = chars.indexOf(plainChar);
    let keyIndex = chars.indexOf(keyChar);

    if (plainIndex === -1) {
      encodedText += plainChar; // keep characters not in chars unchanged
    } else {
      let newIndex = (plainIndex + keyIndex) % chars.length;
      encodedText += chars[newIndex];
    }
  }

  return encodedText;
};

// Function to decode encodedText using a Vigenère cipher with a keyword
const decode = (encodedText) => {
  const keyword = commonConstants.encryptionKey.toLowerCase();
  const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
  let decodedText = "";

  for (let i = 0; i < encodedText.length; i++) {
    let encodedChar = encodedText[i];
    let keyChar = keyword[i % keyword.length];
    let encodedIndex = chars.indexOf(encodedChar);
    let keyIndex = chars.indexOf(keyChar);

    if (encodedIndex === -1) {
      decodedText += encodedChar; // keep characters not in chars unchanged
    } else {
      let newIndex = (encodedIndex - keyIndex + chars.length) % chars.length;
      decodedText += chars[newIndex];
    }
  }

  return decodedText;
};

function getKeyByValue(object, value) {
  return Object.keys(object).find((key) => object[key] === value);
}

function getSensorType(sensor) {
  const sensorTypeId = (sensor && parseInt(sensor.sensor_type_id, 10)) || 0;
  const constantSensorType = commonConstants.sensorType;
  if (constantSensorType.energy === sensorTypeId) {
    return "energy";
  } else if (constantSensorType.temperature === sensorTypeId) {
    return "temperature";
  } else if (constantSensorType.solar === sensorTypeId) {
    return "solar";
  } else if (constantSensorType.solarImportExport === sensorTypeId) {
    return "solarImportExport";
  } else {
    return "energey";
  }
}

function isEnergySensor(sensor) {
  return getSensorType(sensor) === "energy";
}

function isSolarSensor(sensor) {
  return getSensorType(sensor) === "solar";
}

function isSolarImportExportSensor(sensor) {
  return getSensorType(sensor) === "solarImportExport";
}

function isTemperatureSensor(sensor) {
  return getSensorType(sensor) === "temperature";
}

export {
  appendScript,
  convertToOptions,
  decode,
  encode,
  formatCurrency,
  formatEmail,
  formatNumber,
  formatPhoneNumber,
  getDateRanges,
  getKeyByValue,
  getSelectedSensorParameters,
  getSensorType,
  getTimeStampFromDateRange,
  getValueFromArray,
  isEnergySensor,
  isSolarImportExportSensor,
  isSolarSensor,
  isTemperatureSensor,
  LocalTimeStampToUTC,
  removeEmptyObjects,
  setTimeZoneDiff,
  timeStampDateFormat,
  UTCTimeStampToLocal,
};
